import React, {useEffect, useRef, useState} from 'react';
import getNewsService from "../../services/GetNews.service";
import HomeCard from "./HomeCard";
import {Button, FormControl, InputLabel, MenuItem, Select, Skeleton, TextField} from "@mui/material";
import HomeError from "./HomeError";
import useIntersectionObserver from "../../hooks/useIntersectionObserver";

function Home(props) {

    const [news, setNews] = useState([]);
    const homeRef = useRef();
    const onScreen = useIntersectionObserver(homeRef, {threshold: 0.5});
    const [lan, setLan] = useState('en');
    const [searchValue, setSearchValue] = useState('');
    const [loading, setLoading] = useState(true);
    const [err, setErr] = useState(false);
    const [errContent, setErrContent] = useState();
    const skeletonItems = new Array(10).fill('');

    function getNews(lan, query) {
        getNewsService.getNews(lan, query)
            .then(res => setNews(res.data.articles))
            .catch(err => {
                setErr(true);
                setErrContent(err);
            });
    }

    function handleQueryChange(e) {
        const currentValue = e.target.value;
        if (currentValue.length === 0) return;
        setSearchValue(currentValue);
    }

    function getNewsByQuery(e) {
        setLoading(true);
        getNews(lan, searchValue.toLowerCase());
    }

    useEffect(() => {
        getNews('en', 'all');
    }, []);

    useEffect(() => {
        if (news.length === 0) return;
        setLoading(false);
    }, [news]);

    const handleLanChange = (event) => {
        setLan(event.target.value);
        setLoading(true);
        if (searchValue) {
            getNews(event.target.value, searchValue.toLowerCase());
        } else {
            getNews(event.target.value, 'all');
        }
    };

    return (
        <div className="home">
            <div className={'home-filters home-' + onScreen} ref={homeRef}>
                <TextField id="standard-basic" label="Search" variant="standard" onChange={handleQueryChange}/>
                <Button variant="contained" onClick={getNewsByQuery}>Get</Button>
                <FormControl sx={{width: '150px'}}>
                    <InputLabel id="demo-simple-select-label">Language</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={lan}
                        label="Age"
                        onChange={handleLanChange}
                    >
                        <MenuItem value='en'>English</MenuItem>
                        <MenuItem value='de'>Germany</MenuItem>
                        <MenuItem value='uk'>Ukrainian</MenuItem>
                        <MenuItem value='fr'>French</MenuItem>
                        <MenuItem value='ja'>Japanese</MenuItem>
                        <MenuItem value='pt'>Portuguese</MenuItem>
                        <MenuItem value='es'>Spanish</MenuItem>
                        <MenuItem value='it'>Italian</MenuItem>
                    </Select>
                </FormControl>
            </div>
            <div className="home-cards">
                {err ? <HomeError condition={errContent.response.status} description={errContent.message}/> :
                    loading ?
                        skeletonItems.map((item, index) => <div className="skeleton-card" key={index}>
                            <Skeleton width={400} height={300}/>
                            <Skeleton/>
                            <Skeleton/>
                            <Skeleton/>
                        </div>)
                        :
                        news?.map((item, index) => <HomeCard
                            key={index}
                            img={item.image}
                            title={item.title}
                            description={item.description}
                            content={item.content}
                            author={item.source.name}
                            authorUrl={item.source.url}
                            published={item.publishedAt.toString().replace('Z', '').replace('T', ' | ').replaceAll('-', '/')}
                        />)
                }
            </div>
        </div>
    );
}

export default Home;